import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";
import "../../Styles/patientDetails.css"

const AddNewVisit = ({ patientVisits, patientId, caseId, actionstatus }) => {
  const { verifyTokenAndRedirect } = useAuth();
  const { patientData, setPatientData, setSelectedVisit } = usePatient();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    verifyTokenAndRedirect();
  }, []);

  const handleNewVisit = useCallback(async () => {
    try {
      setLoading(true);

      if (!patientVisits || patientVisits.length === 0) {
        alert("Visit data not yet loaded.");
        return;
      }

      const updatedPatientData = {
        ...patientData,
        ACTION_STATUS: "ADD_NEW_VISIT",
      };

      const maxVisitId =
        patientVisits.length > 0
          ? Math.max(...patientVisits.map((v) => v.VISIT_ID))
          : 0;

      const newVisitId = maxVisitId + 1;

      setPatientData(updatedPatientData);
      setSelectedVisit(newVisitId);

      navigate(`/visits/${patientId}/${caseId}/${newVisitId}`);
    } catch (error) {
      console.error("Error creating new visit:", error);
    } finally {
      setLoading(false);
    }
  }, [patientVisits, patientData, navigate, patientId, caseId]);

  return (
    <div>
      <button
        className={`add-visit-btn ${loading ? "loading" : ""}`}
        onClick={handleNewVisit}
        disabled={loading}
      >
        {loading ? "Adding Visit..." : "➕ Add Visit"}
      </button>
    </div>
  );
};

export default AddNewVisit;
